
import React, {FC, useState} from 'react';
import {ApptProps} from 'components/ApptDetails2';
import Button from 'components/Button';
import {createReserveAppt, setupStore} from 'components/checkout/setup';
import ArrowDownIcon from 'components/icons/ArrowDown';
import ArrowUpIcon from 'components/icons/ArrowUp';
import {useContextHolder} from 'components/useHolder/context';
import {usePrices} from 'components/utils/usePrices';
import {useToggle} from 'hooks/useToggle';
import {Parsed} from 'templates/booking/Booking/ModalContent/parse';
import {createSuccessLink} from 'templates/booking/Success/useSuccess';

import PriceSelect from './PriceSelect';

import * as styles from './styles.module.scss';

type OptionsProps = {
	appt: ApptProps
	membership: Parsed['membership']
};

const Options: FC<OptionsProps> = ({appt, membership}) => {
	const [selected, setSelect] = useState<number>(-1);
	const {open, toggle} = useToggle(false);
	const {isLoading, hasError, id, oneTime} = usePrices();
	const holder = useContextHolder();

	if (isLoading) {
		return (
			<div className={styles.loading}>
				Loading packages...
			</div>
		);
	}

	if (hasError) {
		return (
			<div className={styles.error}>
				Error loading packages, please refresh the page.
			</div>
		);
	}

	if (!oneTime || !id) {
		return (
			<div className={styles.error}>
				Incomplete pricing data, please refresh the page.
			</div>
		);
	}

	const onRenew = () => {
		setupStore(createReserveAppt({
			appt: appt.id,
			hold: holder.id,
			interval: membership.interval,
			quantity: membership.count,
			redirect: createSuccessLink(),
		}));
	};

	const onPurchase = () => {
		setupStore(createReserveAppt({
			appt: appt.id,
			hold: holder.id,
			quantity: selected + 1,
			redirect: createSuccessLink(),
		}));
	};

	return (
		<>
			<Button variant='primary' onClick={onRenew}>
				Renew early
			</Button>
			<div className={styles.options}>
				<Button className={styles.button} variant='text' onClick={toggle}>
					Looking for a one-time purchase?
					{open ? <ArrowUpIcon /> : <ArrowDownIcon />}
				</Button>
				{open && (
					<>
						<div className={styles.prices}>
							{oneTime.map((px: number, idx: number) => (
								<PriceSelect
									key={idx}
									qty={idx + 1}
									px={px}
									selected={selected === idx}
									onSelect={() => setSelect(idx)}
								/>
							))}
						</div>
						<Button variant='primary' onClick={onPurchase} disabled={selected === -1}>
							Continue to payment
						</Button>
					</>
				)}
			</div>
		</>
	);
};

export default Options;
